import { IDomain } from "../components/types/genericTypes";
// const root = "https://emtuat.edelweiss.in/edelmw-login-uat/login",

const dev: IDomain = {
  root: "http://localhost:8080",
  key_clock_vendor: "https://authuat.nuvamawealth.com/dev/app-auth/",
  jmw_client_docs: "https://vamauat.nuvamawealth.com/library-documentation/",
  jmw_partner_docs: "https://vamauat.nuvamawealth.com/partner-documentation/",
  jmw_order_trade_docs:
    "https://www.hypersync.in/hs_interactive_fintech_feeds/",
  jmw: "https://nmwuat1.nuvamawealth.com/",
  jmw_content: "edelmw-content-uat/content/",
  jmw_login: "edelmw-login-uat/login/",
  python_language:
    "https://nmwuat1.nuvamawealth.com/exe/app/Python_APIConnect/APIConnect-2.0.3.tar.gz",
  c_language:
    "https://nmwuat1.nuvamawealth.com/exe/app/Cs_APIConnect/CSharp_Lib_V_2.0.2.zip",

  java_language:
    "https://www.nuvamawealth.com/ewwebimages/webfiles/download/Java_APIConnect/Java_Lib_V_2.0.8.zip",

  node_language:
    "https://nmwuat1.nuvamawealth.com/exe/app/Node_APIConnect/api_connect_nodejs-2.0.3.tgz",
  appId: "9e5481c0130b8bba8190e52bdc5038ba",
  cleverTapId: "TEST-6Z6-556-W55Z",
  taskLead: "https://nmwuat1.nuvamawealth.com/",
  appIdKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNTkwOTg1Njg1LCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNjYzMDUxY2ZiYWM3ZDY5OWExYzU5Yjk2MDQ4YjUwZTciLCJpc3MiOiJlbXQiLCJleHAiOjE2MjI1MjE5ODUsImlhdCI6MTU5MDk4NTk4NX0.6jabTWX6dFXyX4RNAcD1kggLZIyv33Xeauxe00Z4-38",
  rootUrl: "https://vamauat.nuvamawealth.com/",
  openNewAcc: "https://onboardinguat.nuvamawealth.com/",
};

const uat: IDomain = {
  root: "https://vamauat.nuvamawealth.com" + process.env.PUBLIC_URL,
  jmw: "https://nmwuat1.nuvamawealth.com/",
  jmw_client_docs: "https://vamauat.nuvamawealth.com/library-documentation",
  jmw_partner_docs: "https://vamauat.nuvamawealth.com/partner-documentation/",
  key_clock_vendor: "https://authuat.nuvamawealth.com/dev/app-auth/",
  jmw_order_trade_docs:
    "https://www.hypersync.in/hs_interactive_fintech_feeds/",
  jmw_content: "edelmw-content-uat/content/",
  python_language:
    "https://nmwuat1.nuvamawealth.com/exe/app/Python_APIConnect/APIConnect-2.0.3.tar.gz",
  c_language:
    "https://nmwuat1.nuvamawealth.com/exe/app/Cs_APIConnect/CSharp_Lib_V_2.0.2.zip",

  java_language:
    "https://www.nuvamawealth.com/ewwebimages/webfiles/download/Java_APIConnect/Java_Lib_V_2.0.8.zip",

  node_language:
    "https://nmwuat1.nuvamawealth.com/exe/app/Node_APIConnect/api_connect_nodejs-2.0.3.tgz",
  jmw_login: "edelmw-login-uat/login/",
  appId: "562dbc488cb09c8a8f27222c7954bc12",
  taskLead: "https://nmwuat1.nuvamawealth.com/",
  cleverTapId: "6K9-KW7-745Z",
  appIdKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNTkwOTg1Njg1LCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNjYzMDUxY2ZiYWM3ZDY5OWExYzU5Yjk2MDQ4YjUwZTciLCJpc3MiOiJlbXQiLCJleHAiOjE2MjI1MjE5ODUsImlhdCI6MTU5MDk4NTk4NX0.6jabTWX6dFXyX4RNAcD1kggLZIyv33Xeauxe00Z4-38",
  rootUrl: "https://vamauat.nuvamawealth.com/",
  openNewAcc: "https://onboardinguat.nuvamawealth.com/",
};

const cug: IDomain = {
  root: "https://vamacug.nuvamawealth.com" + process.env.PUBLIC_URL,
  jmw: "https://nmwcug.nuvamawealth.com/",
  key_clock_vendor: "https://auth.nuvamawealth.com/cug/app-auth/",
  jmw_client_docs: "https://vamacug.nuvamawealth.com/library-documentation",
  jmw_partner_docs: "https://vamacug.nuvamawealth.com/partner-documentation",
  jmw_order_trade_docs:
    "https://www.hypersync.in/hs_interactive_fintech_feeds/",
  jmw_content: "edelmw-content-cug/content/",
  jmw_login: "edelmw-login-cug/login/",
  python_language:
    "https://nmwuat1.nuvamawealth.com/exe/app/Python_APIConnect_cug/APIConnect-2.0.0.tar.gz",
  c_language:
    "https://nmwuat1.nuvamawealth.com/exe/app/Cs_APIConnect_cug/CSharp_Lib_V_2.0.0.zip",

  java_language:
    "https://www.nuvamawealth.com/ewwebimages/webfiles/download/Java_APIConnect/Java_Lib_V_2.0.8.zip",
  node_language:
    "https://nmwuat1.nuvamawealth.com/exe/app/Node_APIConnect_cug/api_connect_nodejs-2.0.0.tgz",

  appId: "562dbc488cb09c8a8f27222c7954bc12",
  cleverTapId: "6K9-KW7-745Z",
  taskLead: "https://nd.nuvamawealth.com/",
  appIdKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNTc5MjQxODMyLCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNGZlNjhiNzUzNjc4NGUzNDA3YzNlY2YxOWJlN2M0YWQiLCJpc3MiOiJlbXQiLCJleHAiOjE2MTA3NzgxMzIsImlhdCI6MTU3OTI0MjEzMn0.IR-PKf1Jjr69bsERFmMeuZrZ2RafBDiTGgKA6Ygofdo",
  rootUrl: "https://www.nuvamawealth.com/",
  openNewAcc: "https://onboarding.nuvamawealth.com/",
};

const prod: IDomain = {
  root: "https://www.nuvamawealth.com" + process.env.PUBLIC_URL,
  jmw: "https://nw.nuvamawealth.com/",
  jmw_content: "edelmw-content/content/",
  key_clock_vendor: "https://auth.nuvamawealth.com/app-auth/",
  jmw_client_docs: "https://www.nuvamawealth.com/library-documentation",
  jmw_partner_docs: "https://www.nuvamawealth.com/partner-documentation",
  jmw_order_trade_docs:
    "https://www.hypersync.in/hs_interactive_fintech_feeds/",
  jmw_login: "edelmw-login/login/",
  python_language: "https://pypi.org/project/APIConnect",
  node_language: "https://www.npmjs.com/package/api_connect_nodejs",
  c_language: "https://www.nuvamawealth.com/ewwebimages/webfiles/download/Cs_APIConnect/CSharp_Lib_V_2.0.4.zip",
  java_language: "https://www.nuvamawealth.com/ewwebimages/webfiles/download/Java_APIConnect/Java_Lib_V_2.0.10.zip",
  appId: "4fe68b7536784e3407c3ecf19be7c4ad",
  cleverTapId: "6K9-KW7-745Z",
  taskLead: "https://nw.nuvamawealth.com/",
  appIdKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNTc5MjQxODMyLCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNGZlNjhiNzUzNjc4NGUzNDA3YzNlY2YxOWJlN2M0YWQiLCJpc3MiOiJlbXQiLCJleHAiOjE2MTA3NzgxMzIsImlhdCI6MTU3OTI0MjEzMn0.IR-PKf1Jjr69bsERFmMeuZrZ2RafBDiTGgKA6Ygofdo",
  rootUrl: "https://www.nuvamawealth.com/",
  openNewAcc: "https://onboarding.nuvamawealth.com/",
};

export const config: IDomain =
  process.env.REACT_APP_ENV === "production"
    ? prod
    : process.env.REACT_APP_ENV === "uat"
    ? uat
    : dev;

const configURL = {
  root: config.root,
  appidkey: config.appIdKey,
  appid: config.appId,
  rootUrl: config.rootUrl,
  jmw: config.jmw,
  key_clock_vendor: config.key_clock_vendor,
  jmw_client_docs: config.jmw_client_docs,
  jmw_partner_docs: config.jmw_partner_docs,
  jmw_order_trade_docs: config.jmw_order_trade_docs,
  jmw_content: config.jmw_content,
  jmw_login: config.jmw_login,
  python_language: config.python_language,
  c_language: config.c_language,
  java_language: config.java_language,
  node_language: config.node_language,
  taskLead: config.taskLead,
};

const urlConfig = {
  // Add common config values here
  ...configURL,
};

export default urlConfig;
